import { NgModule } from "@angular/core";
import { DRCSummaryComponent } from './summary/drc-summary.component'
import { CommonModule } from "@angular/common";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { UnitService } from "../drc-valuation/utils/unit.service";

@NgModule({
  imports: [
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  declarations: [
    DRCSummaryComponent
  ],
  exports: [
    DRCSummaryComponent
  ],
  providers: [
    provideNgxMask(),
    UnitService
  ]
})
export class DRCValuationSummaryModule {}